import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink } from 'react-router-dom';
import { Breadcrumb, Divider, Table } from "antd";
import moment from "moment";
import StatementLine from "../StatementLine/StatementLine";
import SpanNumberFormat from "../../common/SpanNumberFormat";

const StatementDetails = (props) => {
  const {
    statement,
    isStatementLoaded,
    handleUpdateLine,
    resetStatement,
    handleSetProcessableStatus,
    isEditable,
  } = props;

  const { tenantProperties } = useSelector((state) => state.tenants);
  const taxTypeRus = tenantProperties.companyIdentityAttributeRus;

  useEffect(() => () => resetStatement(), []);

  if (!isStatementLoaded) return null;

  const statementDataColumns = [
    {
      title: "Дата выписки",
      dataIndex: "batchDate",
      key: "batchDate",
      render: (_, rec) => rec.batch?.batchDate,
    },
    {
      title: "Дата загрузки",
      dataIndex: "uploadedDate",
      key: "uploadedDate",
      render: (_, rec) =>
        rec.batchInfo?.uploadedDate
          ? moment(rec.batchInfo.uploadedDate).format("DD.MM.YYYY HH:mm:ss")
          : "",
    },
    {
      title: "Статус",
      dataIndex: "batchStatus",
      key: "batchStatus",
      render: (_, rec) => rec.batch?.batchStatus?.name,
    },
    {
      title: "Загрузил",
      dataIndex: "uploadedUser",
      key: "uploadedUser",
      render: (_, rec) => {
        const firstName = rec.batchInfo?.uploadedUser?.userInfo?.firstName;
        const lastName = rec.batchInfo?.uploadedUser?.userInfo?.lastName;
        const uploadedUser = [lastName, firstName].filter((name) => Boolean(name)).join(" ");
        return uploadedUser;
      },
    },
    {
      title: "Количество платежей",
      dataIndex: "linesCount",
      key: "linesCount",
      render: (_, rec) => SpanNumberFormat({ amount: rec.batchInfo?.linesCount, fractSize: 0 }),
      width: "180px",
    },
    {
      title: "Сумма",
      dataIndex: "linesSumAmount",
      key: "linesSumAmount",
      render: (_, rec) => SpanNumberFormat({ amount: rec.batchInfo?.linesSumAmount }),
    },
    {
      title: "Дата обработки",
      dataIndex: "processedDate",
      key: "processedDate",
      render: (_, rec) =>
        rec.batchInfo?.processedDate
          ? moment(rec.batchInfo.processedDate).format("DD.MM.YYYY HH:mm:ss")
          : "",
    },
    {
      title: "Обработал",
      dataIndex: "processedUser",
      key: "processedUser",
      render: (_, rec) => {
        if (!rec.batchInfo?.processedUser) return "";
        const firstName = rec.batchInfo?.processedUser?.userInfo?.firstName;
        const lastName = rec.batchInfo?.processedUser?.userInfo?.lastName;
        const processedUser = [lastName, firstName].filter((name) => Boolean(name)).join(" ");
        return processedUser;
      },
    },
  ];

  return (
    <>
      <Breadcrumb className="statements__breadcrumb">
        <Breadcrumb.Item>
          <NavLink to="/statements">Банковские выписки</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{statement.batch?.fileName}</Breadcrumb.Item>
      </Breadcrumb>
      <h1>{statement.batch?.fileName}</h1>
      <Divider className="divider_thin" />
      <Table
        columns={statementDataColumns}
        dataSource={[{ ...statement, key: 0 }]}
        size="small"
        pagination={false}
        style={{ marginBottom: "30px" }}
        className="table__noHover"
      />
      {statement.lineHolders.map((lineHolder) => (
        <div key={lineHolder.line.id}>
          <StatementLine
            handleUpdateLine={handleUpdateLine}
            lineHolder={lineHolder}
            isEditable={isEditable}
            taxTypeRus={taxTypeRus}
            handleSetProcessableStatus={handleSetProcessableStatus}
          />
        </div>
      ))}
    </>
  );
};

export default StatementDetails;
